import React, {Component} from 'react'
import {Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
import Swal from "sweetalert2";
import CurrencyInput from "react-currency-input-field";
import {withTourGuide} from "../../../guideComponent/withTourGuide";

class AddFinance extends Component {
  constructor(props) {
    super(props)
    this.state = {
      prosesSimpan: false
    }
    this.triggerGuideOnce = this.triggerGuideOnce.bind(this)
  }

  triggerGuideOnce = (e, config) => {
      const { showGuide, isGuideActive, disabledKeys } = this.props;
      const target = e?.currentTarget ?? null;
      if (!target || !config?.key) return;
      if (disabledKeys?.includes(config.key)) return;
      if (isGuideActive) return;
      if (typeof showGuide !== 'function') return;
      showGuide(target, config);
  };

  handleAdd = () => {
    this.setState({ prosesSimpan: true})
    let form = {
      finance_cat: this.props.data.finance_cat,
      finance_jumlah: this.props.data.finance_jumlah,
      finance_desc: this.props.data.finance_desc,
      finance_date: this.props.data.finance_date,
      finance_type: this.props.data.finance_type,
      fin_term_id: this.props.data.fin_term_id,
    }
    this.props.request("finance/add", form, 'POST')
      .then((response) => {
        if (response && response.success) {
          this.props.changeState({
            modal_add: false,
          }, () => this.props.loadData())
          Swal.fire({
            title: 'Berhasil!',
            text: response.message,
            icon: 'success',
            confirmButtonText: 'OK'
          })
        } else if (response) {
          Swal.fire({
            title: 'Gagal!',
            text: response.message,
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        }
      })
    this.setState({
      prosesSimpan: false
    })
    this.props.changeState({
      finance_cat: "",
      finance_jumlah: "",
      finance_desc: "",
      finance_date: "",
      finance_type: "",
      fin_term_id: "",
    })
  }

  render() {
    return (
      <Modal isOpen={this.props.modal_add} toggle={() => this.props.changeState({ modal_add: false })} style={{ maxWidth: "1000px"}} zIndex={999}>
        <ModalHeader className="pengumuman-modal-header" toggle={() => this.props.changeState({ modal_add: false })}>
          <div className='presensi-modal-title'>Tambah Laporan Keuangan</div>
        </ModalHeader>
          <ModalBody className="pengumuman-modal-body">
              <div className="row p-3">
                  <div className="col">
                      <div className="form-group">
                          <label className="pengumuman-label-input">
                              Kategori laporan Keuangan
                          </label>
                          <select
                              className="form-control col-xl-12 col-md-12"
                              name="fin_term_id"
                              value={this.props.data.fin_term_id}
                              onChange={this.props.handleChange}
                              onPointerEnter={(e) => {
                                  this.triggerGuideOnce(e, {
                                      key: "keuanganKategori",
                                      title: "Kategori Laporan Keuangan",
                                      content: "Pilih kategori laporan keuangan yang sesuai dari daftar yang tersedia."
                                  });
                              }}
                          >
                              <option value="">Pilih kategori</option>
                              {this.props.data.dataTerm.length > 0 &&
                                  this.props.data.dataTerm.map((item) => {
                                      return (
                                          <option value={item.fin_term_id}>{item.fin_term_name}</option>
                                      )
                                  })
                              }
                          </select>
                      </div>
                      <div className="form-group">
                          <label className="pengumuman-label-input">
                              Jumlah
                          </label>
                          <CurrencyInput
                              id="finance_jumlah"
                              name="finance_jumlah"
                              className="form-control col-xl-12 col-md-12"
                              placeholder="000"
                              value={this.props.data.finance_jumlah}
                              decimalSeparator=","
                              groupSeparator="."
                              prefix="Rp. "
                              onValueChange={(value) => {
                                  this.props.handleChange({
                                      target: {
                                          name: "finance_jumlah",
                                          value: value ? parseInt(value.replace(/\./g, '')) : 0
                                      }
                                  })
                              }}
                              onPointerEnter={(e) => {
                                  this.triggerGuideOnce(e, {
                                      key: "keuanganJumlah",
                                      title: "Jumlah",
                                      content: "Masukkan jumlah nominal laporan keuangan dalam format rupiah."
                                  });
                              }}
                          />
                      </div>
                      <div className="form-group">
                          <label className="pengumuman-label-input">
                              Deskripsi laporan keuangan
                          </label>
                          <textarea
                              name="finance_desc"
                              value={this.props.data.finance_desc}
                              className="form-control col-xl-12 col-md-12"
                              placeholder="Masukkan deskripsi laporan keuangan"
                              onChange={this.props.handleChange}
                              onPointerEnter={(e) => {
                                  this.triggerGuideOnce(e, {
                                      key: "keuanganDeskripsi",
                                      title: "Deskripsi Laporan Keuangan",
                                      content: "Masukkan keterangan atau deskripsi tambahan mengenai laporan keuangan ini."
                                  });
                              }}
                          />
                      </div>
                      <div className="form-group">
                          <label className="pengumuman-label-input">
                              Tanggal
                          </label>
                          <input
                              type="date"
                              name="finance_date"
                              value={this.props.data.finance_date}
                              className="form-control col-xl-12 col-md-12"
                              placeholder="Masukkan tanggal laporan keuangan"
                              onChange={this.props.handleChange}
                              onPointerEnter={(e) => {
                                  this.triggerGuideOnce(e, {
                                      key: "keuanganTanggal",
                                      title: "Tanggal",
                                      content: "Pilih tanggal pencatatan atau pengajuan laporan keuangan."
                                  });
                              }}
                          />
                      </div>
                  </div>
              </div>
          </ModalBody>
        <ModalFooter className="pengumuman-modal-footer">
          <button
            onClick={() => this.props.changeState({modal_add: false})}
            className='btn text-capitalize batalkan-add-jamker'>Batal
          </button>
          <button
            className='btn btn-primary text-capitalize' disabled={this.state.prosesSimpan}
            style={{padding: "8px 14px", fontWeight: 500, fontSize: "14px", lineHeight: "24px"}}
            onClick={this.handleAdd}>{this.state.prosesSimpan ? "Menyimpan" : "Simpan"}
          </button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default withTourGuide(AddFinance);